import { Component, DoCheck, OnDestroy } from '@angular/core';
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";

import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";

@Component({
  selector: 'app-advanced-value-widget',
  templateUrl: './latest-advanced-widget.component.html',
  styleUrls: ['./latest-advanced-widget.component.css']
})
export class LatestAdvancedWidgetComponent extends MultiSourceMultiValueWidget implements DoCheck {
  public w: any;
  ranges: any[] = [];
  public point: SharedPoint;
  public alternative: SharedPoint;
  highlighted: boolean = false;

  ngDoCheck(){
    this.ranges.push(Object.assign((<any>this.widget).default,{style:"default"}));
    this.ranges.push(Object.assign((<any>this.widget).primary,{style:"primary"}));
    this.ranges.push(Object.assign((<any>this.widget).success,{style:"success"}));
    this.ranges.push(Object.assign((<any>this.widget).info,{style:"info"}));
    this.ranges.push(Object.assign((<any>this.widget).warning,{style:"warning"}));
    this.ranges.push(Object.assign((<any>this.widget).danger,{style:"danger"}));
  }

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[] = ["timeSeriesHover", "timeSeriesUnhover"];
  override timeSeriesEvent(type: string, uri: string): void {
     if (type === 'timeSeriesHover') {
      this.highlighted = true;
    } else if (type === 'timeSeriesUnhover') {
      this.highlighted = false;
    }
  }

  hover(){
    this.events.trigger('timeSeriesHover', (<any>this.widget)?.timeSeriesList[0].uri, null);
  }

  unhover(){
    this.events.trigger('timeSeriesUnhover', (<any>this.widget)?.timeSeriesList[0].uri, null);  
  }

  override widgetDataLoadComplete(): void {
      
  }
  
  widgetBeforeInit(): void {
    this.w = this.widget;
  }

  widgetAfterInit(): void {
  }

  widgetLiveDataLoaded(s: any) {
    if (s != null && s.uri != null){
      // pop the first item, push the new one
      if (this.seriesCache == null){
        this.seriesCache = {uri:s.uri,values:[]} as SharedSeries;
      }
      if (this.seriesCache) {
        const value = Math.round(s.point.value*1000)/1000;
        var item = this.seriesCache;
        if (item.values == null){
          item.values = this.tidyHistory(null);
        }

        var values = [...item.values];
        if (values.length > this.history){
          values.shift();  
        }
        values.push({uri:s.uri, value:value, timeStamp: s.point.timeStamp} as SharedPoint);
        item.values = this.tidyHistory(values);
      }
      this.widgetDataLoaded(this.seriesCache);
    }
  }

  tidyHistory(values: SharedPoint[]) : SharedPoint[]{
    if (values == null || values.length == 0){
      values = [];
    }
    while (values.length < this.history){
      values.unshift({value:0} as SharedPoint);
    }
    while (values.length > this.history){
      values.shift();
    }
    return values;
  }

  seriesCache: SharedSeries;
  values: number[];
  history: number = 25;

  widgetDataLoadTimeout(){
    
  }
  
  widgetDataLoaded(series: SharedSeries): void {
    this.seriesCache = series;
    if (this.seriesCache != null && this.seriesCache.values != null){
      var v = [];
      for (let val of series.values){
        v.push(val.value);
      }
      if (series.values == null || series.values.length == 0) return;
      this.values = v;
      if ((<any>this.widget).display == "Average"){
        const sum = series.values.reduce((a, b) => a + b.value, 0);
        const avg = (sum / series.values.length) || 0;
        this.point = {uri:series.uri, value:avg} as SharedPoint;
        if ((<any>this.widget).significantFigures == null){
          this.point = {uri:series.uri, value:avg} as SharedPoint;
        } else {
          this.point = {uri:series.uri, value:this.round(avg, (<any>this.widget).significantFigures)} as SharedPoint;
        }   
      }
      else if ((<any>this.widget).display == "Maximum"){
        this.point = series.values.sort((a,b)=>b.value-a.value)[0];
      }
      else if ((<any>this.widget).display == "Minimum"){
        var sorted = series.values.sort((a,b)=>b.value-a.value);
        this.point = sorted[sorted.length-1];
      }
      else if ((<any>this.widget).display == "Change"){
        var first = series.values[0].value;
        var last = series.values[series.values.length-1].value;
        if ((<any>this.widget).significantFigures == null){
          this.point = {uri:series.uri, value:(last-first)} as SharedPoint;
        } else {
          this.point = {uri:series.uri, value:this.round((last-first), (<any>this.widget).significantFigures)} as SharedPoint;
        }        
      }
      else /* assume latest */ {
        this.point = series.values[series.values.length-1];
      }

      if ((<any>this.widget).alternative == "Average"){
        const sum = series.values.reduce((a, b) => a + b.value, 0);
        const avg = (sum / series.values.length) || 0;
        if ((<any>this.widget).significantFigures == null){
          this.alternative = {uri:series.uri, value:avg} as SharedPoint;
        } else {
          this.alternative = {uri:series.uri, value:this.round(avg, (<any>this.widget).significantFigures)} as SharedPoint;
        }        
      }
      else if ((<any>this.widget).alternative == "Maximum"){
        this.alternative = series.values.sort((a,b)=>b.value-a.value)[0];
      }
      else if ((<any>this.widget).alternative == "Minimum"){
        var sorted = series.values.sort((a,b)=>b.value-a.value);
        this.alternative = sorted[sorted.length-1];
      }
      else if ((<any>this.widget).alternative == "Change"){
        var first = series.values[0].value;
        var last = series.values[series.values.length-1].value;
        this.alternative = {uri:series.uri, value:(last-first)} as SharedPoint;
        if ((<any>this.widget).significantFigures == null){
          this.alternative = {uri:series.uri, value:(last-first)} as SharedPoint;
        } else {
          this.alternative = {uri:series.uri, value:this.round(last-first, (<any>this.widget).significantFigures)} as SharedPoint;
        }     
      }
      else /* assume latest */ {
        this.alternative = series.values[series.values.length-1];
      }
    }
  }

  round(num, figures){
    if (num === 0) return 0;
    const d = Math.ceil(Math.log10(num < 0 ? -num : num));
    const power = figures - d;
    const magnitude = Math.pow(10, power);
    const shifted = Math.round(num * magnitude);
    return shifted / magnitude;
  }

  public getIcon(){
    if ((<any>this.widget).alternative == "Average"){
      return "fa-ellipsis-h"
    }
    else if ((<any>this.widget).alternative == "Maximum"){
      return "fa-plus-circle";      
    }
    else if ((<any>this.widget).alternative == "Minimum"){
      return "fa-minus-circle";
    }
    else if ((<any>this.widget).alternative == "Change"){
      if (this.alternative.value > 0){
        return "fa-level-up";
      } else if (this.alternative.value < 0){
        return "fa-level-down";
      }else{
        return "fa-level-up";
      }
    }
    else /* assume latest */ {
      return "fa-bolt"; 
    }
  }

  public getStyle(point:any){
    var opacity = "bg-opacity-30";
    if ((<any>this.widget).opacity != null){
      opacity = "bg-opacity-" + (<any>this.widget).opacity;
    }
    if (point && point.value != null){
      for (let range of this.ranges){
        if (range.min != null && range.max != null && range.min <= point.value && range.max >= point.value) {
          return "bg-" + range.style + " " + opacity;
        }
      }
    }
    // no data loaded, so default to offline
    return "bg-white bg-opacity-10";// + " " + opacity;
  }

}
